module.exports = __webpack_public_path__ + "img/service-01.8821fb40.svg";